import React from 'react';

import { Button } from '@mui/material';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { CHECK_RATES } from '../../constants/LoansCalculator';

export const CheckRatesButton = ({ loanAmountValue, onCheckRates }) => {
  return (
    <Button
      sx={{
        '&:hover': { backgroundColor: 'black', color: 'white' },
        '&:disabled': { backgroundColor: 'gray', color: 'white', opacity: 0.8 },
        m: 0,
        color: 'white',
        textTransform: 'initial',
        backgroundColor: 'black',
        float: 'right',
        width: '150px',
        borderRadius: '10px',
        height: '48px',
      }}
      disabled={loanAmountValue <= 0}
      onClick={onCheckRates}
    >
      {' '}
      {CHECK_RATES} &nbsp; <ArrowForwardIcon />
    </Button>
  );
};
